import { CryptoCurrencies } from "../enums/cryptoCurrency";
import { Networks } from "../enums/networks";

export const getDecimalsByCrypto = (cryptoCurrency) => {
	if (cryptoCurrency === CryptoCurrencies.BTC || cryptoCurrency === CryptoCurrencies.LTC || cryptoCurrency === CryptoCurrencies.DOGE) {
		return 8;
	} else if (
		cryptoCurrency === CryptoCurrencies.USDT ||
		cryptoCurrency === "USDC_BASE" ||
		cryptoCurrency === CryptoCurrencies.USDC ||
		cryptoCurrency === CryptoCurrencies.TRX ||
		cryptoCurrency === CryptoCurrencies.XRP
	) {
		return 6;
	} else if (cryptoCurrency === CryptoCurrencies.ETH || cryptoCurrency === "ETH_BASE") {
		return 18;
	} else {
		return 2;
	}
};

export const shortAddress = (address) =>
	address.toString().length >= 13
		? `${address.toString().substring(0, 8)}....${address.toString().substring(address.length - 5)}`
		: address.toString();

export const getConfirmationsByCryptoNetwork = (cryptoCurrency, network) => {
	switch (network) {
		case Networks.BITCOIN:
			return 2;
		case Networks.ETHEREUM:
			if (cryptoCurrency === CryptoCurrencies.ETHEREUM) {
				return 12;
			} else {
				return 24;
			}
		case Networks.BASE:
			if (cryptoCurrency === CryptoCurrencies.ETHEREUM) {
				return 12;
			} else {
				return 24;
			}
		case Networks.TRON:
			return 12;
		case Networks.LITECOIN:
			return 6;
		case Networks.RIPPLE:
			return 10;
		case Networks.DOGECOIN:
			return 20;
		default:
			return 10;
	}
};
